import APIService from "@/services/APIService.js"; 

export default {
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/movimentacoesBlindada/get-all/${includeExpiredRecords}`);
  },
  getById(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/get-by-id/${id}`);
  },
  getByStatus(status) {
    status = status.toUpperCase();
    return APIService.apiCall().get(`/movimentacoesBlindada/get-by-status/${status}`);
  },
  getVersoesByData(data) {
    return APIService.apiCall().get(`/movimentacoesBlindada/get-versoes-by-data/${data}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/movimentacoesBlindada/salvar/${postData.id}`, JSON.stringify(postData))
  },
  executar(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/executar/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/duplicar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/excluir/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/movimentacoesBlindada/baixarArquivoResultado/${id}`, { responseType: 'blob', ...config });
  },
  baixarLogsTecnicos(id) {
    return APIService.apiCall().get(`/movimentacoesBlindada/baixarLogsTecnicos/${id}`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  },
  getArquivoModelo(tipo) {
    return APIService.apiCall().get(`movimentacoesBlindada/baixarArquivoModelo/${tipo}`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  }
};
